import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";

export class ProfileUserInformationWorkExperienceModel extends Model {
  constructor(
    public id: number = 0,
    public companyName: string = "",
    public jobTitle: string = "",
    public location: string = "",
    public currentlyEmployedFlag: boolean = false,
    public startDate: string = "",
    public endDate: string = "",
    public description: string = "",
    public createdAt: string = "",
    public updatedAt: string = "",
  ) {
    super();
  }

  public static create(model: ProfileUserInformationWorkExperienceModel): ProfileUserInformationWorkExperienceModel {
    return createModel<ProfileUserInformationWorkExperienceModel>(ProfileUserInformationWorkExperienceModel, { ...model });
  }
}

export class ProfileWorkExperienceCreateModel {
  constructor(
    public id: number = 0,
    public companyName: string = "",
    public jobTitle: string = "",
    public location: string = "",
    public currentlyEmployedFlag: boolean = false,
    public startDate: string = "",
    public endDate: string = "",
    public description: string = "",
  ) {
  }
}